import React from 'react';
import { Localize } from '@kokolingo/localisation';
import { object, string } from 'yup';

export default object().shape({
  activationKey: string().required(() => (
    <Localize id="error.activationKeyRequired" />
  )),
});
